import React from "react"
import Image from "./image"
import { Button } from '@material-ui/core'
import { Link } from "gatsby"
import { useTranslation } from "react-i18next"

const PostlaunchBox = ({ outofstock, currentRegion, currentProduct, bannerDisplay, updateBannerDisplay }) => {
  const hideHandleClick = () => {
    const isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      const outofstockArray = localStorage.getItem('outofstock') ? JSON.parse(localStorage.getItem('outofstock')) : {};
      const itemKey = currentProduct + '-' + currentRegion
      outofstockArray[itemKey] = true
      localStorage.setItem('outofstock', JSON.stringify(outofstockArray));
    }
    updateBannerDisplay(false)
  }

  const { t } = useTranslation()

  return (
    <div
      className="postlaunchBox"
      style={{
        display: bannerDisplay ? 'block' : 'none',
        position: `absolute`,
        height: `100%`,
        width: `100%`,
        left: 0,
        top: 0,
        backgroundColor: `#fff`,
        zIndex: 1000,
        justifyContent: `center`
      }}>
      <div
        className="postlaunchBox__wrapper"
      >
        <Image
          filename="postlaunch.png"
          classname="postlaunchBox__image"
        />
        <div className="postlaunchBox__date">
          { t('postLaunch.date') }
        </div>
        <div className="postlaunchBox__desc">
          { t('postLaunch.desc') }
        </div>
        <div className="buttonGroup">
          <Button className="basicButton" onClick={() => hideHandleClick()}>
            { t('postLaunch.customisation') }
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PostlaunchBox
